import { Record, List } from "immutable";
import { AnyAction } from "redux";

import { LOADING_STATE } from "@typings/reduxThunkActions";

import {
  ACTION_FAIL,
  ACTION_PENDING,
  ACTION_SUCCESS,
} from "@services/AsyncActionCreatorFactory";

import { GiftCardsReducer } from "./giftCards.typings";
import {
  FETCH_PAYMENT_METHODS,
  SELECT_PAYMENT_METHOD,
} from "./giftCards.actions";

const initialState = Record<GiftCardsReducer>({
  paymentMethods: Record({
    status: LOADING_STATE.IDLE,
    data: List(),
  })(),
  selectedPaymentMethod: null,
});

const giftCardsReducer = (
  store: Record<GiftCardsReducer> = initialState(),
  action: AnyAction,
): Record<GiftCardsReducer> => {
  const { type, payload } = action;

  switch (type) {
    case `${FETCH_PAYMENT_METHODS}${ACTION_PENDING}`: {
      return store.setIn(["paymentMethods", "status"], LOADING_STATE.LOADING);
    }
    case `${FETCH_PAYMENT_METHODS}${ACTION_FAIL}`: {
      return store.setIn(["paymentMethods", "status"], LOADING_STATE.FAILED);
    }
    case `${FETCH_PAYMENT_METHODS}${ACTION_SUCCESS}`: {
      return store
        .setIn(["paymentMethods", "data"], List(payload.data))
        .setIn(["paymentMethods", "status"], LOADING_STATE.SUCCEEDED);
    }
    case SELECT_PAYMENT_METHOD: {
      return store.set("selectedPaymentMethod", payload.paymentMethod);
    }
    default:
      return store;
  }
};

export { giftCardsReducer };
